import { render, staticRenderFns } from "./Promoted.vue?vue&type=template&id=6f38df31&"
import script from "./Promoted.vue?vue&type=script&lang=js&"
export * from "./Promoted.vue?vue&type=script&lang=js&"
import style0 from "./Promoted.vue?vue&type=style&index=0&id=6f38df31&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VImg})
